<template lang="pug">
	.comment(:class='{"blink" : blink}')
		.current
			.top
				.label
					p.name {{ comment.user }}
					p.date {{ parseTimestamp( comment.createdAt )}}
				p.reply(@click='reply( comment )') Reply
			.text
				p {{ comment.text }}
		.replies(v-if='replyThreadKey')
			comment-thread(
				:section-ref='sectionRef'
				:parent='replyThreadKey'
				:increment='2'
				:parent-state='state'
				:active-comment-path='newPath'

				@reply='reply'
				@update-state='childState = $event'
				@update-thread-length='updateThreadLength'
			)

		.view-replies(v-if='comment.commentCount' @click='handleReplies')
			p(v-if='parentState === "loading"') Loading
			p(v-else) {{ replyString }} Replies ( {{ comment.commentCount - threadLength }} )
</template>

<script>
// eslint-disable-next-line no-unused-vars
import HasProperty from '@/lib/utils';

export default {
	name : 'comment',

	props : {
		comment : {
			required : true,
			type     : Object
		},
		sectionRef : {
			type : Object,
		},
		// State of parent comment-thread
		parentState : {
			type : String,
		},
		activeCommentPath : {
			type : Array,
		},
	},

	data : () => ( {
		replyThreadKey : '',
		threadLength   : 0,
		load           : false,
		state          : 'loaded',

		blink : false,

		// State of child comment-thread
		childState : '',
	} ),

	beforeCreate() {
		this.$options.components.CommentThread = require( './CommentThread.vue' ).default;
	},

	computed : {
		replyString() {

			if ( !this.replyThreadKey.length ) {
				return 'View';
			}

			if ( this.comment.commentCount === this.threadLength ) {
				return 'Hide';
			}

			return 'View More';

		},

		newPath() {
			return this.activeCommentPath.slice( 1, this.activeCommentPath.length );
		}
	},
	// mounted() {
	// 	console.log( this.comment );
	// },

	watch : {

		childState( childState ) {
			this.state = childState;
		},

		activeCommentPath : {
			immediate : true,
			deep      : true,
			handler( path ) {
				this.openReply( path );
			}
		}

	},

	methods : {
		reply( comment ) {
			this.$emit( 'reply', comment );
		},

		parseTimestamp( timestamp ) {
			const date = timestamp.toDate();

			const [mm, dd, yyyy] = [
				date.getMonth() + 1,
				date.getDate(),
				date.getFullYear(),
			];

			let [hours, minutes] = [
				date.getHours(),
				date.getMinutes(),
			];

			const ampm = hours >= 12 ? 'PM' : 'AM';

			hours %= 12; // Convert time to 12-hour format.
			hours = hours || 12; // The hour `0` should be `12`

			minutes = minutes < 10 ? `0${minutes}` : minutes; // add leading 0 to minutes less than 10

			return `${mm}/${dd}/${yyyy} ${hours}:${minutes} ${ampm}`;
		},

		handleReplies() {

			if ( !this.replyThreadKey.length ) {
				return this.viewReplies( this.comment.id );
			}

			if ( this.comment.commentCount === this.threadLength ) {
				return this.hideReplies();
			}

			return this.loadMoreReplies();

		},

		viewReplies( id ) {
			this.replyThreadKey = id;
		},

		openReply( path ) {

			const currentPathId = path[0];
			const { id } = this.comment;

			if ( currentPathId === id ) {
				this.viewReplies( id );
			}

			if ( path.length === 1 && currentPathId === id ) {
				this.blink = true;
			}

		},

		hideReplies() {
			this.replyThreadKey = '';
			this.threadLength   = 0;
		},

		loadMoreReplies() {
			// Setting this to loading will trigger the the parentState watcher in comment-thread
			// the thread will loadMore and set its state to loaded when done. Then emit its state
			// This will trigger the childState watch in comments and state the comment state back to loaded
			this.state = 'loading';
		},

		updateThreadLength( length ) {
			this.threadLength = length;
		}
	},

};
</script>

<style lang="scss">

.comment {
	padding: 5px 0;
	border-radius: 5px;

	@keyframes blink {
		from {
			background: rgba(228, 248, 224, 0.8);
		}

		to {
			background: rgba(228, 248, 224, 0);
		}
	}

	&.blink {
		animation: blink 2s 1 forwards;
	}

	+ .comment {
		padding-top: 15px;
	}

	.current {

		.top {
			font-family: 'Josefin Sans', sans-serif;
			display: flex;
			justify-content: space-between;
			margin-bottom: 9px;

			.reply {
				color : #A8B4BE;
				text-transform: uppercase;
				font-weight: 500;
				cursor: pointer;
				font-size: 14px;
				letter-spacing: .15em;
			}

			.label {
				display: flex;
				font-size: 14px;
				letter-spacing: .15em;

				.name {
					color: $color-primary;
					margin-right: 10px;
					text-transform: uppercase;
				}

				.date {
					color: $color-primary--variant-1;
				}
			}
		}

		.text {
			font-weight: 300;
			font-size: 14px;
		}
	}

	.view-replies {
		margin-top: 10px;
		font-size: 12px;
		cursor: pointer;
		font-weight: 600;

		p {
			margin-left: 0px;
			letter-spacing: .15em;
			text-transform: uppercase;
		}
	}
}

@media only screen and ( max-width: 640px ) {

	.comment {

		.current {

			.top {
				align-items: center;

				.label {
					flex-direction: column;
				}
			}
		}
	}
}
</style>
